/**
 * DM W5-0a — `pm_item.kind`, the explicit role of a `dm.item` in the work tree (c5119 K-A).
 * Only `dm.item` carries one; `data.kind` (dm.doc / dm.area / dm.job) is a different field.
 */
export const DM_ITEM_KIND_VALUES = ['wave', 'slice', 'container', 'standalone'];
export const DM_ITEM_KIND_VALUES_TEXT = DM_ITEM_KIND_VALUES.join(' | ');
/** The one type the kind column belongs to. */
export const DM_ITEM_KIND_TYPE = 'dm.item';
/** W5-1 (K3) — `data.kind` on a dm.item is sunset; the dm.job queue container's natural key is the one value kept. */
export const DM_ITEM_DATA_KIND_QUEUE = 'queue';
export function isDmItemKind(value) {
    return typeof value === 'string' && DM_ITEM_KIND_VALUES.includes(value);
}
//# sourceMappingURL=dmItemKind.js.map